import { cn } from '@/utils';

interface KhiimoriLogoProps {
  size?: number;
  className?: string;
}

export function KhiimoriLogo({ size = 32, className }: KhiimoriLogoProps) {
  return (
    <img
      src="/brand/icon-128.png"
      alt="Khiimori"
      width={size}
      height={size}
      className={cn('rounded-lg object-cover shrink-0', className)}
      draggable={false}
    />
  );
}
